<template>
    <li class="canvas-list-item">
        <slot />
    </li>
</template>
<script>
export default {
    name:'UnorderedListItem'
}
</script>